import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

function DropDownBasic(props) {
  const [ddlTitle, setDdlTitle] = useState(props.title);

  //   onClickHandler = (event) => {
  //     const value = event.target.innerHTML;
  //     this.setState({ value });
  //   };

  console.log(
    'props.title' + props.title
  );
  console.log(
    'props.id' + props.id
  );
  console.log(
    'props.options' + props.options.length
  );

  const onSelect = (id, value) => {
    setDdlTitle(value);
    props.ddlOnSelectFunction();
  };

  return (
    <DropdownButton id="{props.id}" title="select product">
      {props.options.map((item) => (
        // <option key={item.value} value={item.value}>
        //   {item.name}
        // </option>

        <Dropdown.Item
          key={item.value}
          onClick={onSelect(item.value, item.name)}
        >
          {item.name}
        </Dropdown.Item>
      ))}
      {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
    </DropdownButton>
  );
}

export default DropDownBasic;
